import '../../App.css';
import React, { useContext } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';

function ModalEditarPeriodicidade({ currentPage }) {
    const { EditarPeriodicidade, EdicaoPeriodicidade, setEdicaoPeriodicidade, setModalEditarPeriodicidade, setError } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    const editar = (e) => {
        if (e) e.preventDefault();
        if (!EdicaoPeriodicidade.nome) {
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        EditarPeriodicidade(currentPage)
            .then(() => {
                setModalEditarPeriodicidade(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleChange = (event) => {
        setEdicaoPeriodicidade({ ...EdicaoPeriodicidade, [event.target.name]: event.target.value })
    }

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Editar periodicidade</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditarPeriodicidade(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control maxLength={255} defaultValue={EdicaoPeriodicidade.nome} onChange={handleChange} name="nome" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descrição</Form.Label>
                                    <Form.Control maxLength={255} defaultValue={EdicaoPeriodicidade.descricao} onChange={handleChange} name="descricao" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditarPeriodicidade(false)}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                            <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={(e) => {
                                e.preventDefault();
                                editar();
                            }}>Salvar</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEditarPeriodicidade